import { Namespace } from "rdflib";
export const rdf = Namespace("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
export const solid = Namespace("http://www.w3.org/ns/solid/terms#");
export const pim = Namespace("http://www.w3.org/ns/pim/space#");
export const ldp = Namespace("http://www.w3.org/ns/ldp#");
//# sourceMappingURL=index.js.map